import React from 'react'
import PropTypes from 'prop-types'
import { findKey } from 'lodash'

import CargoOperationsDetailsCargill from './cargoOperationsDetailsCargill/CargoOperationsDetailsCargill'
import CargoOperationsDetailsYara from './cargoOperationsDetailsYara/CargoOperationsDetailsYara'
import { CARGO_DETAILS_CONFIG, CARGO_DETAILS_TYPE } from '../../../js/constants'

const CargoOperationsDetails = props => {
  const cargoDetailsType = findKey(CARGO_DETAILS_CONFIG, config => config.includes(props.identifiers.terminalId))

  if (cargoDetailsType === CARGO_DETAILS_TYPE.cargill) {
    return (
      <CargoOperationsDetailsCargill
        order={props.order}
        ship={props.ship}
        identifiers={props.identifiers}
        berthName={props.berthName}
        loadStationName={props.loadStationName}
        authToken={props.authToken}
        customFetch={props.customFetch}
        readOnly={props.readOnly}
        closeModal={props.closeModal}
      />
    )
  }

  if (cargoDetailsType === CARGO_DETAILS_TYPE.yara) {
    return (
      <CargoOperationsDetailsYara
        ship={props.ship}
        identifiers={props.identifiers}
        order={props.order}
        authToken={props.authToken}
        customFetch={props.customFetch}
        readOnly={props.readOnly}
        closeModal={props.closeModal}
      />
    )
  }

  return null
}

CargoOperationsDetails.propTypes = {
  identifiers: PropTypes.shape({
    terminalId: PropTypes.string.isRequired,
    // orderId and terminalVisitId not known when adding new terminal visit
    orderId: PropTypes.string,
    terminalVisitId: PropTypes.string
  }).isRequired,
  order: PropTypes.object,
  ship: PropTypes.object,
  berthName: PropTypes.string,
  loadStationName: PropTypes.string,
  authToken: PropTypes.string,
  customFetch: PropTypes.func.isRequired,
  readOnly: PropTypes.bool.isRequired,
  terminalName: PropTypes.string,
  closeModal: PropTypes.func.isRequired
}

export default CargoOperationsDetails
